// Copyright (c) StrangeBee 2024

import { classList } from '@Helpers/className';
import React, { ReactElement, ReactNode } from 'react';

import './ColumnTitle.scss';

interface ColumnTitleProps {
    children: ReactNode;
    className?: string;
}

export const ColumnTitle = ({ children, className }: ColumnTitleProps): ReactElement => (
    <div className={classList('column-render__title', className)}>{children}</div>
);
